import React, { useContext, useState, useEffect } from "react";
import { InputContext } from "../../../shared/contexts/InputContext";
import { OutputContext } from "../../../shared/contexts/OutputContext";
import BarChart from "./BarChart";
import {
  lumpSumColour,
  defaultChartOptions,
  getMaxScaleValue,
} from "./chartUtils";
import { sumValues } from "../../../shared/utils/formatters";
import { capitaliseFirstLetter } from "../../../shared/utils/formatters";

const LumpSumBarChart = ({ retirementType }) => {
  const { inputs } = useContext(InputContext);
  const { outputs, loading } = useContext(OutputContext);
  const [chartData, setChartData] = useState(null);

  const maxScaleValue = getMaxScaleValue(outputs, "lump sum");

  useEffect(() => {
    const graphData = outputs.filter(
      (item) =>
        item.retirementType === retirementType && item.benefitType == "lump_sum"
    );

    let leftChoice = { lump_sum: 0 };
    let rightChoice = { lump_sum: 0 };

    graphData.forEach((item) => {
      if (item.benefitType === "lump_sum") {
        if (item.remedyChoice === "legacy") {
          leftChoice.lump_sum = sumValues(item.values);
        } else if (item.remedyChoice === "reform") {
          rightChoice.lump_sum = sumValues(item.values);
        }
      }
    });

    setChartData({
      labels: ["Choose Legacy", "Choose alpha"],
      datasets: [
        {
          label: "Lump Sum",
          data: [leftChoice.lump_sum, rightChoice.lump_sum],
          backgroundColor: lumpSumColour,
          borderRadius: 6,
        },
      ],
    });
  }, [inputs, outputs, loading]);

  const handleSegmentClick = (info) => {
    console.log("Segment clicked:", info);
  };

  if (!chartData) return null;

  const chartOptions = {
    ...defaultChartOptions,
    scales: {
      ...defaultChartOptions.scales,
      y: {
        ...defaultChartOptions.scales.y,
        max: maxScaleValue,
      },
    },
    plugins: {
      ...defaultChartOptions.plugins,
      title: {
        ...defaultChartOptions.plugins.title,
        text: `Estimated Lump Sum at ${capitaliseFirstLetter(
          retirementType
        )} Retirement`,
      },
      subtitle: {
        ...defaultChartOptions.plugins.subtitle,
        text: `Values are in ${inputs.projectionSettings.realNominalSwitch} terms`,
      },
    },
  };

  return (
    <BarChart
      chartData={chartData}
      chartOptions={chartOptions}
      onSegmentClick={handleSegmentClick}
    />
  );
};

export default LumpSumBarChart;
